import React, { FunctionComponent } from "react";

type MenuProps = {
  children: React.ReactNode;
  id: string;
};

export const Menu: FunctionComponent<MenuProps> = ({ children, id }) => {
  return (
    <nav className="tw-menu" id={id}>
      {children}
    </nav>
  );
};
